<template>
  <div class="banner">
    <!-- <div class="mm">深圳市达通源科技有限公司</div> -->
    <div class="banner-img">
      <img src="../assets/img/bannerImg.png" />
    </div>
    <!-- <div class="banner-title">
      <div class="vision" ref="vision">
          <p class="vision-p">
            我们的愿景
          </p>
          <p class="vision-text">
            受人赞誉的行业典范，持续成长的卓越企业。
          </p>
      </div>

        <div class="vision v-icon" ref="pilocy">
          <div class="vision-content">
            <p class="vision-p">
              核心价值观
            </p>
          </div>

          <p class="vision-icon-right">
            <span>诚信</span>
            <span>责任</span>
            <span>专业</span>
            <span>团队</span>
            <span>创新</span>
          </p>
        </div>

        <div class="vision v-icon" ref="visionRight">
          <div class="vision-content">
            <p class="vision-p">
              质量方针
            </p>
          </div>

          <p class="vision-icon">
            <span>公正</span>
            <span>科学</span>
            <span>准确</span>
            <span>改进</span>
          </p>
        </div>

        <div class="vision v-icon" ref="visionLeft">
          <div class="vision-content">
            <p class="vision-p">
              服务理念
            </p>
          </div>

          <p class="vision-icon-right">
            <span >用心服务</span>
            <span >创造感动</span>
          </p>
        </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: "../assets/img/bannerImg.png"
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 1000px) {
  .banner{
    height: 25vw!important;
    .vision{
      margin-bottom: 10vw!important;
    }
    .mm{
      height: 28vw!important;
      line-height: 28vw!important;
    }
  }
}
.banner {
  user-select: none;
  pointer-events: none;
  width: 100%;
  height: 16vw;
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  .mm {
    position: absolute;
    width: 100%;
    height: 22vw;
    line-height: 22vw;
    animation: fadeEnlarge 2s ease forwards;
    font-size: 2vw;
    font-family: 宋体;
    font-weight: 800;
    color: #409EFF;
    text-align: center;
    z-index: 100;
  }

  img {
    position: absolute;
    //width: 1240px;
    height: 100%;
    width: 100%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &-title {
    top: 2vw;
    position: absolute;
    color: #fff;
    font-size: 1.8vw;
    font-weight: 400;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    .vision:nth-child(odd){
      animation: fadeInLeft 2s ease forwards;
    }
    .vision:nth-child(even){
      animation: fadeInRight 2s ease forwards;
    }
    .vision{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      text-align: left;
      width: 45%;
      margin: 0vw 2vw;
      color: black;
      margin-bottom: 4vw;
      .vision-p{
        font-size: 1.8vw;
        font-weight: 600;
        font-family: 宋体;
      }
      .vision-text{
        font-weight: 600;
        font-size: 1.5vw;
        font-family: 宋体;
        margin-top: 1.5vw;
      }
      .vision-icon{
        font-family: 宋体;
        display: flex;
        flex-wrap: nowrap;
        margin-top: 1.5vw;
        justify-content: flex-start;
        font-weight: 600;
        font-size: 1.5vw;
        span{
          
        }
        span:nth-child(n+2){
          margin-left: 4vw;
        }
      }

      .vision-icon-right{
        font-family: 宋体;
        display: flex;
        flex-wrap: nowrap;
        margin-top: 1.5vw;
        justify-content: flex-end;
        font-weight: 600;
        font-size: 1.5vw;
        span:nth-child(n+2){
          margin-left: 4vw;
        }
      }
    }
    .vision:nth-child(2){
      text-align: right;
    }
    .vision:nth-child(4){
      text-align: right;
    }
  }
}

@keyframes fadeInLeft {

0% {
  opacity: 0;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}

100% {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInRight {
  // 0% {
  //   opacity: 0;
  //   transform: translateX(5vw);
  // }

  // 100% {
  //   opacity: 1;
  //   transform: translateY(0);
  // }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeEnlarge {
  0% {
    opacity: 0;
    transform: scale(0);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>